import router from '@/router'
import Settings from '@/custom/classes/settings'
class FiltersHelper {
  constructor () {
    this.route = router.app.$route
    this.settings = new Settings()
  }

  getServerCallFilters (filters) {
    let data = {}
    for (let i = 0; i < filters.length; i++) {
      let filter = filters[i]
      if (this.route.query[filter.designator] == undefined) {
        continue
      }
      data[filter.designator] = this.route.query[filter.designator]
    }
    return data
  }

  getOwnerFilterOptions () {
    let options = []
    let owners = this.settings.get({ path: 'owners' })
    for (let i = 0; i < owners.length; i++) {
      let owner = owners[i]
      options.push({
        text: owner.name,
        value: owner.name
      })
    }
    options.push({
      text: 'NULL',
      value: 'NULL'
    })
    return options
  }

  getOfficeSizeFilterOptions () {
    return [
      {
        text: 'משרד גדול',
        value: 'משרד גדול'
      },
      {
        text: 'משרד בינוני',
        value: 'משרד בינוני'
      },
      {
        text: 'משרד קטן',
        value: 'משרד קטן'
      },
      {
        text: 'משרד בוטיק',
        value: 'משרד בוטיק'
      },
      {
        text: 'חברה',
        value: 'חברה'
      },
      {
        text: 'לא משפטי',
        value: 'לא משפטי'
      }
    ]
  }

  getParentEnvFilterOptions () {
    return [
      {
        text: 'Suitup',
        value: 'Suitup'
      },
      {
        text: 'Rebase',
        value: 'Rebase'
      },
      {
        text: 'Office',
        value: 'Office'
      }
    ]
  }

  isFilterOptionSelected (filter, option) {
    let url_filter_value = (this.route.query[filter.designator] || '').split(
      ','
    )
    return url_filter_value.includes(option.value + '')
  }
}

export default FiltersHelper
